import { createRouter, createWebHistory } from 'vue-router'
import RichiediAssistenza from './views/RichiediAssistenza.vue'
import RegistraGaranzia from './views/RegistraGaranzia.vue'

const routes = [
  { path: '/', component: RichiediAssistenza },
  { path: '/registra-garanzia', component: RegistraGaranzia }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
